import { PageHero } from '../../components/PageHero';
import programsHero from '../../assets/gsa/programs-hero.webp';
import { ProgramsCatalogueBody } from './components/ProgramsCatalogueBody';

/**
 * The GSA catalogue.
 *
 * Which catalogue a learner sees is decided from who they are, in
 * `pages/Programs/index.tsx`: a degree learner gets `DegreePrograms`, everyone
 * else gets this. It used to be decided by a `?type=` query parameter cast
 * straight to `ProgramType`, which only fell back when the parameter was
 * absent — so `/programs?type=anything` survived the cast, indexed a hero
 * record with no such key, and threw on the next line. A user-editable url
 * should not be able to pick a page's data set, let alone blank the page.
 */
const HERO = {
  label: 'Global Skills Academy',
  title: 'Build the AI skills the workforce needs now.',
  subtitle: 'Learn from experts, and innovate for real-world impact.',
};

export const ProgramsCatalogue = () => (
  <div className="bg-background pb-16">
    <PageHero
      backgroundImage={programsHero}
      showDecorations
    >
      <p className="text-2xl font-medium text-saffron">{HERO.label}</p>
      <h1 className="mt-3 text-4xl font-semibold md:text-5xl">{HERO.title}</h1>
      <p className="mt-3 max-w-3xl text-lg text-white">{HERO.subtitle}</p>
    </PageHero>

    <ProgramsCatalogueBody
      type="gsa"
      className="mx-auto max-w-screen-2xl px-4 sm:px-8 md:px-12 py-10"
    />
  </div>
);
